var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("EntityLandingHeader", {
        attrs: {
          "background-image-url": _vm.backgroundImageUrl,
          entity: _vm.venue
        }
      }),
      _vm._v(" "),
      _c("section", { staticClass: "filters" }, [
        _c(
          "div",
          { staticClass: "filters__filter" },
          [
            _c(
              "FxSelect",
              {
                attrs: {
                  "default-option": { label: "All Events", value: null },
                  "disable-native": true,
                  options: _vm.categoryOptions
                },
                on: { input: _vm.onCategoryKeySelected },
                model: {
                  value: _vm.categoryKey,
                  callback: function($$v) {
                    _vm.categoryKey = $$v
                  },
                  expression: "categoryKey"
                }
              },
              [
                _c("span", {
                  staticClass: "icon-chevron-lg-down",
                  attrs: { slot: "caret" },
                  slot: "caret"
                })
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filters__filter" },
          [
            _c("span", {
              staticClass: "icon-calendar-blank filters__icon-calendar"
            }),
            _vm._v(" "),
            _c(
              "fx-date-range",
              {
                attrs: {
                  align: "left",
                  "data-e2e": "search.date-filter",
                  "min-date": "today",
                  "custom-option-copy": "Choose Date",
                  "default-option-copy": "Any Date",
                  presets: _vm.dateRangeFilterPresets
                },
                on: { input: _vm.onDateRangeInput },
                model: {
                  value: _vm.dateRange,
                  callback: function($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange"
                }
              },
              [
                _c("span", {
                  staticClass: "icon-chevron-lg-down",
                  attrs: { slot: "caret" },
                  slot: "caret"
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("EventList", {
            attrs: {
              events: _vm.events,
              "filters-applied": Boolean(_vm.categoryKey || _vm.dateRange),
              "format-points": _vm.formatPoints,
              "is-loading-events": _vm.isLoadingEvents,
              "is-loading-more-events": _vm.isLoadingMoreEvents,
              "is-loyalty-pricing": _vm.$store.state.isRedeemingLoyaltyPoints,
              "load-more-copy": "Show More",
              "loading-more-copy": "Loading More Events...",
              "make-event-route": _vm.makeEventRoute,
              "on-event-click": _vm.onEventClick,
              pagination: _vm.pagination
            },
            on: { "load-more-events": _vm.onLoadMoreEvents }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }